import { catchError } from 'rxjs/operators';
import {
  Component,
  ViewChild,
  Optional,
  Input,
  ComponentFactoryResolver,
  AfterContentInit
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user.service';
import { ProfileService } from '../../../services/profile.services';
import { Configuration } from '../../conf/app.constants';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { of, forkJoin } from 'rxjs';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { ViewContainerRef, OnDestroy } from '@angular/core';
import { BasicInfoComponentService } from './DossierBasicInfoService';
import { ComponentLoaderService } from '../../componentLoaderService';
import { AppConfiguration } from '../../conf/app.configuration';
import { ServiceLocator } from '../../ServiceLocator';
import { getSimpleIdentifierFromString } from '../../api/plyca-dtos';


@Component({
  selector: 'dossierBasicInfo',
  templateUrl: 'dossierBasicInfo.template.html',
  providers: [BasicInfoComponentService, ComponentLoaderService]
})
export class dossierBasicInfoComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  @Input()
  public dossier: any;
  public dossierId: any;
  public dossierIdExternal: any;

  // para carga de replyca
  params: string;
  replycaData: any;

  //Otros datos expediente
  profilePubExt: string;
  urlPubExt: string;

  // para controlar si se muestra la cabecera
  @Input()
  public showHeader = true;
  public isPopup = true;

  loaded = false;

  //configuracion
  appConfig: AppConfiguration;
  cliente: any;
  attribInfoLots: string = 'INFO_LOTES_EXP_STD';
  attribInfoAnnuities: string = 'INFO_ANUALIDADES_STD';
  attribInfoRelatedDossiers: string = 'INFO_EXP_RELACIONADOS_STD';

  @ViewChild('otherContainer', { read: ViewContainerRef })
  otherContainer: ViewContainerRef;
  public otherComponentLoaded = false;

  //@ViewChild(BaseChartDirective) chartElement: BaseChartDirective;
  windowHash: any;

  constructor(
    public uiService: UIService,
    public plycaService: PlycaDataService,
    protected route: ActivatedRoute,
    private headerActionsService: HeaderActionsService,
    protected waitService: WaitLoadingService,
    public dialogService: DialogService,
    public translate: TranslateService,
    public configuration: Configuration,
    public profileService: ProfileService,
    protected router: Router,
    public userService: UserService,
    protected basicInfoComponentService: BasicInfoComponentService,
    @Optional() public ref: DynamicDialogRef,
    @Optional() public dialogConfig: DynamicDialogConfig,
    protected componentFactoryResolver: ComponentFactoryResolver
  ) {
    super();
    this.waitService.startWaiting();
    this.appConfig = ServiceLocator.injector.get(AppConfiguration);
    this.cliente = this.appConfig.getValue('cliente');
    if ('AYMAD' === this.cliente) {
      this.attribInfoLots = 'REPLYCA_LOTES_EXP';
      this.attribInfoAnnuities = 'REPLYCA_ANUALIDADES';
      this.attribInfoRelatedDossiers = 'REPLYCA_EXP_RELACIONADOS';
    }
    if (dialogConfig && JSON.stringify(dialogConfig) != '{}') {//ladash empty obj
      this.dossier = dialogConfig['dossier'];
      this.dossierId = dialogConfig['dossierId'];
      this.isPopup = true;
      this.params = 'PROPUESTAID=' + this.dossierId;
    } else {
      this.isPopup = false;
      this.subscribe(this.route.params, params => {
        this.dossierId = params['id'];
        this.params = 'PROPUESTAID=' + this.dossierId;
        // this.params = 'PROPUESTAID=' + this.dossierId.substring(0, 4) + '/' + this.dossierId.substring(4);
      });
    }

  }

  isProcurementProject() {
    return this.dossier.documentClass.identifier === '00000';
  }

  isAMorSDA() {
    return getSimpleIdentifierFromString(this.dossier.classification?.complementarySystem?.identifier) === 'AM'
      || getSimpleIdentifierFromString(this.dossier.classification?.complementarySystem?.identifier) === 'SDA';
  }

  isRegisterContract() {
    return this.dossier.documentClass.identifier === '00600';
  }

  printReplycaTemplate() {
    return ((this.isRegisterContract() || this.isProcurementProject()) && this.replycaData !== undefined) ||
      (this.cliente === 'DIPBAD' && (this.isSpendingProjectDIPBAD || this.isInfrastructurePlanDIPBAD))
  }

  isInfrastructurePlanDIPBAD() {
    return this.dossier?.documentClass?.identifier === '05000';
  }

  isSpendingProjectDIPBAD() {
    return this.dossier.documentClass?.identifier === '05002';
  }

  ngAfterContentInit(): void {
    // Si no llega dossier, comprobamos que llega dossierId y leemos el dossier.
    // Por compatibilidad con los componentes que manejan unicamente project
    if (!this.dossier) {
      this.subscribe(this.plycaService.get(this.configuration.PROJECTENTITY_SERVICE_URL, this.dossierId,
        {
          expand: 'expansionSet:WEBCLIENT_GENERAL_INFO'
        }), param => {
          this.dossier = param;
          this.init();
        });
    } else {
      this.init();
    }
    if (!this.isPopup) {
      this.headerActionsService.clearActions();
    }

    if (this.isPopup) {
      this.windowHash = generateRandomIdentifier();
      this.headerActionsService.clearWindowActions(this.windowHash);
      this.subscribe(this.headerActionsService.addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true, this.windowHash
      ), success => {
        this.close();
      });

    } else {
      //this.headerActionsService.clearActions();
      this.subscribe(this.headerActionsService.addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ), success => {
        this.uiService.routeBack();
      });
    }
  }

  init() {
    this.otherComponentLoaded = this.loadComponent(this.dossier.documentClass.identifier);

    //Identificador externo de un expediente (se utiliza en UPM-RDOC)
    if (this.appConfig.getValue('dossierBasicInfo.customField.idExternal')
      && this.dossier?.customFields) {
      this.dossierIdExternal = this.dossier?.customFields[this.appConfig.getValue('dossierBasicInfo.customField.idExternal')];
    }

    // En AYMAD, los datos mostrados en replyca data usan atributos específicos de REPLYCA.
    // Se elimina esta información de la pestaña para expedientes de contratación.
    if (!this.otherComponentLoaded) {
      if (this.isProcurementProject() && 'AYMAD' !== this.cliente) {
        this.loadReplycaData();
      } else if (this.isRegisterContract()) {
        this.loadReplycaData();
      } else if (this.cliente == 'DIPBAD' && (this.dossier?.documentClass.identifier == '05000' || this.dossier?.documentClass.identifier == '05002')) {
        this.loadReplycaData();
      }
    }
    /* else {
      console.log('DYNAMIC LOADING COMPONENT: ', this.dossier)
      this.loadComponent(this.dossier.documentClass.identifier);
    }*/
    try {
      this.subscribe(this.plycaService.getAttributeValue(
        'PlycaPortal.ContractNotice.PublishedURLs',
        'PROPUESTAID=' + this.dossierId
      ), x => {
        // comprobar si se he publicado en plataformas externas
        if (x && x.values && x.values.length > 0) {
          this.profilePubExt = x.values[0].columns['PERFIL'].value;
          this.urlPubExt = x.values[0].columns['URL'].value;
        }
      });
    } catch { }

    this.loaded = true;
  }

  ngOnDestroy() {
    if (this.dialogConfig && JSON.stringify(this.dialogConfig) != '{}') {
      this.headerActionsService.clearWindowActions(this.windowHash);
    } else {
      this.headerActionsService.clearActions();
    }
    super.ngOnDestroy();
  }

  isGraphicLoaded(): boolean {
    return true;
  }

  loadReplycaData() {
    this.replycaData = {};
    this.subscribe(
      forkJoin([
        this.plycaService.getAttributeValue(
          this.attribInfoLots,
          this.params
        ).pipe(catchError((error: any) => {
          console.log(error)
          return of(undefined)
        })),
        this.plycaService.getAttributeValue(
          this.attribInfoAnnuities,
          this.params
        ).pipe(catchError((error: any) => {
          console.log(error)
          return of(undefined)
        }))
      ]),
      ([res1, res2]) => {
        if (res1) {
          let x = res1;
          let lotes = false;
          // comprobar si hay lotes
          if (x && x.values && x.values.length > 0) {
            this.replycaData['LOTES'] = { 'label': 'lotes', 'values': x, 'identifier': this.attribInfoLots };
          }

        }
        if (res2) {
          let x = res2;
          // comprobar si hay lotes
          if (x && x.values && x.values.length > 0) {

            // HACK PARA ELIMINAR LAS COLUMNS LOTE/DESCRIPCION SI EL EXPEDIENTE NO TIENE LOTES
            // SE HA TOCADO EL TEMPLATE TAMBIEN (NO SE PASA A TABLE COMPONENT EL ID DEL ATRIBUTO PARA FIJAR LAS COLUMNAS QUE APARECEN)
            // VER COMO ELIMINAR ESTE CODIGO
            {
              // si no hay lotes eliminar columnas de lotes
              let _columns = x.values[0].columns;
              let _columns2 = {};
              if (this.replycaData['LOTES'] && this.replycaData['LOTES'].values && this.replycaData['LOTES'].values.length > 0) {
                _columns2['LOTE'] = _columns['LOTE'];
                _columns2['DESCRIPCION'] = _columns['DESCRIPCION'];
                // delete _columns['LOTE'];
                // delete _columns['DESCRIPCION'];
              }
              _columns2['EJERCICIO'] = _columns['EJERCICIO'];
              _columns2['ORGANICA'] = _columns['ORGANICA'];
              _columns2['FUNCIONAL'] = _columns['FUNCIONAL'];
              _columns2['ECONOMICA'] = _columns['ECONOMICA'];
              _columns2['IMPORTE'] = _columns['IMPORTE'];
              x.values[0].columns = _columns2;
            }
            // END HACK

            this.replycaData['ANUALIDADES'] = { 'label': 'lotes', 'values': x, 'identifier': this.attribInfoAnnuities };
          }
        }
        this.waitService.cancelWaiting();
      },
      err => {
        console.log(err)
        this.waitService.cancelWaiting();
      }
    );

    try {
      this.subscribe(this.plycaService.getAttributeValue(
        this.attribInfoRelatedDossiers,
        this.params
      ), x => {
        // comprobar si hay lotes
        if (x && x.values && x.values.length > 0) {
          this.replycaData['RELACIONADOS'] = x.values;
        }
      });
    } catch { }
  }


  linkToRelated(dossierId: string) {
    if (dossierId) {
      this.waitService.startWaiting();
      this.dossierId = dossierId;
      this.params = 'PROPUESTAID=' + this.dossierId;
      this.dossier = undefined;
      this.router.navigate(['/dossierInfo/' + this.normalizaDossierId(dossierId)], { queryParams: { component: 'GENERAL_INFO' } });
    }
  }

  normalizaDossierId(dossierId: string): string {
    if (dossierId.indexOf('/') > 0) {
      return dossierId.substring(0, 4) + dossierId.substring(5);
    } else {

      return dossierId;
    }

  }

  close(): void {
    if (this.isPopup) {
      this.ref.close();
    }
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  getSituationClass() {
    let styleClass = ' badge badge-secondary '; // default class
    if (this.dossier.status.situation) {
      switch (this.dossier.status.situation) {
        case 'Normal': { // normal
          styleClass += 'bg-emphasis';
          break;
        }
        case 'Extinguished': { // Extingido
          styleClass += 'bg-success';
          break;
        }
        case 'Cancelled': { // Cancelado
          styleClass += 'bg-danger';
          break;
        }
        case 'Support': { // Modo soporte
          styleClass += 'bg-secondary';
          break;
        }
        default: {
          styleClass += 'bg-emphasis';
          break;
        }
      }
    }
    return styleClass;
  }

  loadComponent(dossierType: string): boolean {
    let componentLoaded = false;
    if (this.otherContainer) {
      let params = {};
      // INYECTAMOS LA INFORMACION DEL DOSSIER
      params['dossierId'] = this.dossierId;
      params['dossier'] = this.dossier;

      let newCmp = this.basicInfoComponentService.loadComponent(dossierType, this.otherContainer, params);
      if (newCmp) {
        this.subscribe(newCmp);
        componentLoaded = true;
      }
    } else {
      console.log('LOADCOMPONENT PERSONALIZADO: otherContainer no existe todavia');
    }
    return componentLoaded;
  }
}
